import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { CloudUserDto } from '../../dto/CloudUserDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiAddCloudUser = async (dto?: CloudUserDto) => {
  const params: IApiParams = {
    url: '/cloud-user/addCloudUser.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
